export default __webpack_public_path__ + "static/media/jaqueestacomendo.db1dcf08.jpg";